<div class="container" *ngIf="!loading">
    <div class="row ">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Stammdaten bearbeiten
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="personFrom">
                    <div class="row flex">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Anrede:</mat-label>
                                <mat-select formControlName="gender">
                                    <mat-option *ngFor="let sortOption of genderOptions" [value]="sortOption.value">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Anrede <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Titel:</mat-label>
                                <input matInput formControlName="title">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Vorname:</mat-label>
                                <input matInput formControlName="firstName">
                                <mat-error>
                                    Vorname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Nachname:</mat-label>
                                <input matInput formControlName="lastName">
                                <mat-error>
                                    Nachname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Geburtstag:</mat-label>
                                <input matInput formControlName="birthday" type="date">
                                <mat-error>
                                    Geburtstag <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()">
                        Speichern
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div class="row ">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Adresse bearbeiten
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addressFrom">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Straße und Hausnummer:</mat-label>
                                <input matInput formControlName="street">
                                <mat-error>
                                    Straße und Hausnummer <strong>muss</strong>angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>PLZ:</mat-label>
                                <input matInput formControlName="postcode" type="number">
                                <mat-error>
                                    PLZ <strong>muss</strong> angegeben werden
                                </mat-error>

                                <mat-error>
                                    PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                </mat-error>

                                <mat-error>
                                    PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                </mat-error>

                            </mat-form-field>

                            <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                    <mat-label>Ort:</mat-label>
                                    <input matInput formControlName="city">
                                    <mat-error>
                                        Ort <strong>muss</strong> angegeben werden
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()">
                        Speichern
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div class="row ">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Kontaktdaten bearbeiten
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="memberForm">
                    <div class="row flex">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Telefon:</mat-label>
                                <input matInput formControlName="phone" type="number">
                                <mat-error>
                                    Mobilnummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-sm-12">
                            <mat-form-field class="full-width" appearance="standard">
                                <mat-label>Mobil:</mat-label>
                                <input matInput formControlName="mobile" type="number">
                            </mat-form-field>
                        </div> -->
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Mail-Adresse:</mat-label>
                                <input matInput formControlName="email" type="email">
                                <mat-error>
                                    E-mail <strong>muss</strong> angegeben werden
                                </mat-error>
                                <mat-error>
                                    E-mail <strong>muss</strong> gültiges Format haben
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div formGroupName="account">
                            <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                    <mat-label>Nutzername:</mat-label>
                                    <input matInput formControlName="username" type="text">
                                    <mat-error>
                                        Nutzername <strong>muss</strong> angegeben werden
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()">
                        Speichern
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>

<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>